import { supabase } from "@/integrations/supabase/client";

/**
 * Extract the storage path from a Supabase public URL for a given bucket.
 * Returns null if the URL doesn't belong to the bucket.
 */
export const extractStoragePath = (url: string, bucketName: string): string | null => {
  try {
    const marker = `/storage/v1/object/public/${bucketName}/`;
    const idx = url.indexOf(marker);
    if (idx === -1) return null;
    return decodeURIComponent(url.substring(idx + marker.length));
  } catch {
    return null;
  }
};

/**
 * Delete files from a Supabase storage bucket given their public URLs.
 * Silently ignores URLs that don't match the bucket or fail to delete.
 */
export const deleteStorageFiles = async (urls: string[], bucketName: string): Promise<void> => {
  const paths = urls
    .map((url) => extractStoragePath(url, bucketName))
    .filter((p): p is string => p !== null);

  if (paths.length === 0) return;

  await supabase.storage.from(bucketName).remove(paths);
};
